import { apiUploadFilesMultipleWeCom, apiUploadFilesWeCom, ReqUploadFilesMultipleWeCom, ReqUploadFilesWeCom } from "@/api";
import { TABS } from "@/config";
import { useStore } from "@/store";
import { MSG_TYPE, wxSend } from "@/utils/wx";
import useWatch from "./useWatch";
export default () => {
  useWatch(
    TABS.FINANCE,
    async () => {
      console.log("财务");
    },
    {
      isZt: true,
      isSignalr: true,
    }
  );
};

export const sendFile = async <T extends boolean>(fileName: string, fileUrl: string, notSend?: T): Promise<{ data: string; type: MSG_TYPE }> => {
  fileName = getFileName(fileName, fileUrl);
  const params: ReqUploadFilesWeCom = {
    corpId: useStore().getCorpId,
    fileName,
    fileUrl,
  };
  const etx = fileName.slice(fileName.lastIndexOf(".") + 1);
  console.log(params, etx);
  const type = ["jpg", "png"].includes(etx) ? MSG_TYPE.IMAGE : MSG_TYPE.FILE;
  const { data } = await apiUploadFilesWeCom(params);
  if (notSend) return { data, type };
  else wxSend(data, type);
  return { data, type };
};

export const sendFiles = async <T extends boolean>(files: { fileName: string; fileUrl: string }[], notSend?: T): Promise<{ data: string; type: MSG_TYPE }[]> => {
  let etx: string[] = [];
  files.forEach((n) => {
    if (n.fileName.split(".").length == 1) n.fileName += n.fileUrl.split("?")[0].slice(n.fileUrl.lastIndexOf("."));
    etx.push(n.fileName.slice(n.fileName.lastIndexOf(".") + 1));
  });
  const params: ReqUploadFilesMultipleWeCom = {
    corpId: useStore().getCorpId,
    files,
  };
  console.log(params, etx);
  const { data } = await apiUploadFilesMultipleWeCom(params);
  const newArr = data.map((n, i) => ({
    data: n,
    type: ["jpg", "png"].includes(etx[i]) ? MSG_TYPE.IMAGE : MSG_TYPE.FILE,
  }));
  if (!notSend) {
    newArr.forEach((n) => {
      const { data, type } = n;
      wxSend(data, type);
    });
  }
  return newArr;
};

export const getFileName = (fileName: string, fileUrl: string) => {
  fileUrl = fileUrl.split("?")[0];
  if (fileName.split(".").length == 1) fileName += fileUrl.slice(fileUrl.lastIndexOf("."));
  return fileName;
};
